module.exports = __webpack_public_path__ + "img/logo.77db1f78.png";